import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";

/**
 * Loads every (non-deleted) marketing campaign for the admin editor.
 * Distinct from useMarketingCampaigns (participant pause status).
 */
export const useMarketingCampaignsAdmin = () => {
	const queryClient = useQueryClient();
	const queryKey = ["marketing-campaigns-admin"];

	const query = useQuery({
		queryKey: queryKey,

		queryFn: async () => {
			const response = await EndpointsService.dataRetriever.getMarketingCampaigns();
			return response ?? [];
		},
	});

	return {
		...query,
		invalidate: () =>
			queryClient.invalidateQueries({
				queryKey: queryKey,
			}),
	};
};
